let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbG7w")).then(() => parcelRequire('7WYjZ'));